import { Holding } from '@daml.js/dtc-registry-holding/lib/Dtc/Registry/Holding/V3/Holding';
import TemplateContract from './TemplateContract';

type Args = {
  instrumentId: string;
  registrar: string;
  holdings: TemplateContract<Holding>[];
};
export const filterHoldingsByInstrument = (arg: Args) => {
  const { instrumentId, registrar, holdings } = arg;
  return holdings.filter(
    (h) => h.payload.instrument.id === instrumentId && h.payload.instrument.source === registrar,
  );
};
